/**
 * Sprint DDN (Deal Desk Notifications) — MOD-NAV.
 *
 * Pure predicate deciding whether a sidebar nav item should carry the
 * "unseen MD decisions" count badge.
 *
 * CAVEAT (MASTER-PLAN §MOD-NAV): the path `/veda-agro/enquiries` is shared by
 * BOTH the admin "Deal Desk" item AND the sales "Leads" item (and the Veda
 * "Requirements" item). We must badge ONLY the item whose label is literally
 * `Deal Desk` — never the Leads or Requirements items — so the predicate keys
 * on BOTH the path AND the exact label.
 */
export const DEAL_DESK_NAV_PATH = '/veda-agro/enquiries';
export const DEAL_DESK_NAV_LABEL = 'Deal Desk';

export function shouldBadgeDealDesk(
  item: { to?: string; label?: string },
  count: number,
): boolean {
  return (
    item.to === DEAL_DESK_NAV_PATH &&
    item.label === DEAL_DESK_NAV_LABEL &&
    count > 0
  );
}
